import{useContext}from'react';import{RouteContext}from'@shopgate/pwa-common/context';/**
 * Provides the route parameters.
 * @returns {Object}
 */export function useRoute(){var routeContext=useContext(RouteContext);return routeContext;}